import useAffiliatedVisitor from "utils/hooks/useAffiliatedVisitor";
import useUtmSocialVisitor from "utils/hooks/useUtmSocialVisitor";
import useWindowStorage from "utils/hooks/useWindowStorage";

export const PENDING_COUPON_STORAGE_KEY = "PENDING_COUPON";

export default function useExcludeFromAnnual() {
  const [_, { getItem }] = useWindowStorage("localStorage");

  const { isUtmSocialVisitor } = useUtmSocialVisitor();

  const { affiliateCode, isAffiliateVisitor } = useAffiliatedVisitor();

  const pendingCoupon = !!getItem(PENDING_COUPON_STORAGE_KEY);

  const excludeFromAnnual =
    pendingCoupon || isUtmSocialVisitor || isAffiliateVisitor;

  return {
    affiliateCode,
    excludeFromAnnual,
    isAffiliateVisitor,
    isUtmSocialVisitor,
    pendingCoupon,
  };
}
